import apiClient from '@shared/apiClient'

const SERVICE_PATH = 'user-content/shortlist'

export const getApiClient = () => apiClient.partneringOnePlus(SERVICE_PATH)
